import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  isValidToken,
  jwtDecode,
  setSession,
} from '../../pages/collateral-property/api/utils';
import axios from '../../pages/collateral-property/api/axios';
import { CollateralPropertyPartnerEmployeesData } from '../../pages/collateral-property/types';
import endpoints from '../../pages/collateral-property/api/endpoints';
import { IDecodedToken } from '../types';

const getUser = createAsyncThunk(
  'getUser',
  async (id: number | null, thunkAPI) => {
    try {
      const accessToken = localStorage.getItem('propertyAccessToken');
      const refreshToken = localStorage.getItem('propertyRefreshToken');

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken, refreshToken);

        const decoded: IDecodedToken = jwtDecode(accessToken);

        if (id) {
          const _res = await axios.get(
            endpoints.agentNetworkService.partner.employees.item(id)
          );
          const res: CollateralPropertyPartnerEmployeesData = _res.data;

          return { ...res, roles: decoded.realm_access.roles };
        }

        return {
          id: 0,
          firstName: decoded.fio.split(' ')[1],
          lastName: decoded.fio.split(' ')[0],
          middleName: '',
          iin: '',
          email: '',
          emailVerified: true,
          branchId: 0,
          subjectId: decoded.subject_id,
          branch: {
            id: 0,
            regNumber: '',
            name: '',
            partnerId: 0,
            partner: {
              id: 0,
              name: '',
              regNumber: '',
              referralCode: '',
            },
          },
          roles: decoded.realm_access.roles,
        };
      }
      return thunkAPI.rejectWithValue({ message: 'Invalid access token' });
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default getUser;
